module.exports = __webpack_public_path__ + "img/barva-zakladni_81_cervena.1e7ffd78.png";